export default (editor) => {
  const {
    value: {
      fragment: { nodes: fragmentNodes },
      // selection: { isBackward, isForward }
    },
  } = editor;

  if (fragmentNodes.size > 1) {
    // const fragmentNodesArray = fragmentNodes.toArray();
    editor.moveToFocus();

    // if (isBackward) {
    //   const anchorFragment = fragmentNodesArray[fragmentNodesArray.length - 1];

    //   const childNodesArray = anchorFragment.nodes.toArray();

    //   const lastChildNode = childNodesArray[childNodesArray.length - 1];

    //   const fields = lastChildNode.nodes.toArray();
    //   const lastField = fields[fields.length - 1];

    //   editor.moveToStartOfNode(lastField);

    //   return true;
    // }

    // if (isForward) {
    //   const anchorFragment = fragmentNodesArray[0];

    //   const childNodesArray = anchorFragment.nodes.toArray();

    //   const firstChildNode = childNodesArray[0];

    //   const fields = firstChildNode.nodes.toArray();

    //   const anchorField = fields[0];

    //   editor.moveToEndOfNode(anchorField);

    //   return true;
    // }
  }

  return false;
};
